/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_BOX } from "../graphql/updateBox.mutation";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { useBoxId } from "../provider";
import { DELETE_BOX } from "../graphql/deleteBox.mutation";
import { filter } from "lodash";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateBoxMethods extends IPluginMethodMap {
  updateBox(args: any): Promise<any>;
  deleteBox(args: any): Promise<any>;
}

export class UpdateBoxService implements IAgentPlugin {
  readonly methods: IUpdateBoxMethods;

  constructor() {
    this.methods = {
      updateBox: this.updateBox.bind(this),
      deleteBox: this.deleteBox.bind(this),
    };
  }

  async updateBox(args: any) {
    const { boxId } = useBoxId();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      console.log(args?.payload);
      const { costumeID, id, ...payloadWithoutCostumeID } = args?.payload || {};

      // const { costumeID, } = args?.payload || {};
      // return {...config}
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_BOX,
          variables: {
            filter: {
              _id: args?.payload?.id ? args?.payload?.id : boxId,
              costumeID: costumeID ?? "",
            },
            update: {
              // ...args?.payload?.update
              ...payloadWithoutCostumeID,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.updateBox,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  async deleteBox(args: any) {
    const { boxId } = useBoxId();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("delete box", args, boxId);
    try {
      if (client) {
        const res = await client.mutate({
          mutation: DELETE_BOX,
          variables: {
            filter: {
              _id: boxId ?? args?.id,
            },
            reason: args?.reason,
            deleteIfFullyPaid: true,
            deleteReferral: args?.checkboxStatus ?? false,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.updateBox,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
